export default "__VITE_ASSET__Ci8Gahgd__"